import { v4 as uuidV4Origin } from 'uuid';
import { createReducer } from '@reduxjs/toolkit';

import { isPhysicalGiftPage } from 'app/utils/methods/guard';

import { ICard } from './interfaces';
import * as actions from './actions';

// @todo На SSR браузерный uuid работать отказывается. Need to resolve this.
const uuidV4 = () => {
  try {
    return uuidV4Origin();
  } catch {
    return '00000000-0000-0000-0000-000000000000';
  }
};

const initialState: ICard = {
  common: {
    id: 0,
    type: '',
    uuid: '',
    identity: {
      type: '',
      param: '',
      code: '',
    },
    url: '',
    sender: '',
    isShareableLink: false,
  },
  pages: [],
  resources: [],
  meta: {
    hash: null,
    status: 'init',
    state: 'closed',
    progress: 0,
    errors: [],
  },
};

export default createReducer(initialState, (builder) => builder
  .addCase(actions.loadData, (state) => {
    state.meta.hash = uuidV4();
    state.meta.status = 'data-loading';
    state.meta.errors = [];
  })
  .addCase(actions.loadProgress, (state, action) => {
    state.meta.hash = uuidV4();
    state.meta.progress = action.payload.percent;
  })
  .addCase(actions.loadError, (state, action) => {
    state.meta.hash = uuidV4();
    state.meta.status = 'error-fetch';
    state.meta.errors = [
      action.payload.message,
    ];
  })
  .addCase(actions.setData, (state, action) => {
    state.meta.hash = uuidV4();
    state.meta.status = 'data-loaded';
    state.common = action.payload.common;
    state.pages = action.payload.pages;
    state.resources = action.payload.resources;
  })
  .addCase(actions.setStatus, (state, action) => {
    state.meta.hash = uuidV4();
    state.meta.status = action.payload.status;
  })
  .addCase(actions.setState, (state, action) => {
    state.meta.hash = uuidV4();
    state.meta.state = action.payload.state;
  })
  .addCase(actions.updatePage, (state, action) => {
    const pageIndex = state.pages.findIndex((page) => page.id === action.payload.updateId);
    if (pageIndex < 0) {
      return;
    }
    state.pages[pageIndex] = action.payload.page;
    if (action.payload.addResources.length > 0) {
      state.resources.push(...action.payload.addResources);
    }
  })
  .addCase(actions.setPhysicalGiftOpened, (state) => {
    const page = state.pages.find((item) => item.type === 'PageGift');
    if (!isPhysicalGiftPage(page) || !page.items.gift) {
      return;
    }
    page.items.gift.status = 'complete';
  }));
